import { callAPIWhiteToken } from '../config/api';

const PATH_API = process.env.REACT_APP_API;

export async function getEventActive() {
	const url = `${PATH_API}/events/active`;
	return await callAPIWhiteToken({
		url,
		method: 'GET',
	});
}

export async function getDataDetail(slug: string) {
	const url = `${PATH_API}/questionnaire/detail/${slug}`;
	return await callAPIWhiteToken({
		url,
		method: 'GET',
	});
}

export async function getDataDetailUniqueId(slug: string) {
	const url = `${PATH_API}/events/unique-id/${slug}`;
	return await callAPIWhiteToken({
		url,
		method: 'GET',
	});
}

export async function uploadAttendEvent(data: any) {
	const url = `${PATH_API}/events-att/upload`;
	return await callAPIWhiteToken({
		url,
		method: 'POST',
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		data: data,
	});
}

export async function postDataQuestionerTransaction(data: any) {
	const url = `${PATH_API}/questionnaire-transaction`;
	return await callAPIWhiteToken({
		url,
		method: 'POST',
		data: data,
	});
}
